// extracted by mini-css-extract-plugin
module.exports = {"container":"Preloader_container__1pqp5","content":"Preloader_content__2zbM1","center":"Preloader_center__2PBJI","over":"Preloader_over__3bgrK"};